import {useEffect} from "react";
import {useAuthStore} from "../store/authStore";
import * as Sentry from "@sentry/react";

export const useSentryUser = () => {
    const tokenPayload = useAuthStore((state) => state.payload);

    useEffect(() => {
        console.info('[useSentryUser] Detected token payload change.')
        Sentry.setUser({
            email: tokenPayload?.email,
            username: tokenPayload?.name
        });
    }, [tokenPayload]);
};
